import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { Actions } from '../../../types/actions.type';
import { FilterField } from '../../../types/filterField.type';
import { FiltersToolbarAccessor } from '../models/filtersToolbarAccessor.interface';
import { FiltersToolbarActionsTypes } from '../models/filterToolbarActionsTypes.enum';
import { MuFilterToolbarComponent } from '../mu-filter-toolbar/mu-filter-toolbar.component';

@Component({
  selector: 'app-mu-filter-toolbar-sidebar',
  templateUrl: './mu-filter-toolbar-sidebar.component.html',
  styleUrls: ['./mu-filter-toolbar-sidebar.component.sass'],
})
export class MuFilterToolbarSidebarComponent<Data, DataFilters, FlagType> implements OnInit, OnDestroy, AfterViewInit {
  @Input() customClass = 'default-mu-filter-toolbar-sizes';
  @Input() filterToolbar: FiltersToolbarAccessor<DataFilters, FlagType>;
  @Input() disableDeleteFilter: boolean;
  @Input() actions: Actions<FiltersToolbarActionsTypes, DataFilters>;
  filterToolbarVariable: MuFilterToolbarComponent<DataFilters, FlagType>;
  filterFieldList: FilterField<DataFilters>[];

  constructor(private changeDetector: ChangeDetectorRef, private elementRef: ElementRef) {
    changeDetector.detach();
  }

  ngOnInit(): void {
    setTimeout(() => this.changeDetector.reattach());
    document.body.appendChild(this.elementRef.nativeElement);
  }

  ngAfterViewInit() {
    this.filterToolbarVariable = this.filterToolbar?.getFilterToolBar();
    this.filterFieldList = this.filterToolbarVariable?.filterFieldList.filter(f => f.visible);
  }

  /**
   * get filter toolbar variables
   */
  getFilterToolbar(): MuFilterToolbarComponent<DataFilters, FlagType> {
    return this.filterToolbarVariable;
  }

  /**
   * close side bar
   */
  closeSidebar(reset?: boolean): void {
    if (reset) {
      this.filterToolbarVariable.filterList.reset();
      this.filterToolbarVariable.filterList.emitFilterChanges();
      if (this.actions != null) {
        this.actions.emit(FiltersToolbarActionsTypes.FILTERS_CLEARED, this.filterToolbarVariable.filterList.filterData);
      }
    }
    this.filterToolbarVariable.flagList.disable(this.filterToolbarVariable.showFlag);
  }

  /**
   * method to save action
   */
  save(): void {
    this.filterToolbarVariable.filterList.update(this.filterToolbarVariable.modalFilterList.filterData);
    this.filterToolbarVariable.filterList.emitFilterChanges();
    if (this.actions != null) {
      this.actions.emit(FiltersToolbarActionsTypes.FILTERS_CHANGED, this.filterToolbarVariable.filterList.filterData);
    }
    this.closeSidebar();
  }

  ngOnDestroy() {
    document.body.removeChild(this.elementRef.nativeElement);
  }
}
